import Modal, { ModalSize } from "../../../../common/components/Modal";
import AtcProductInfo from "../../v2/AtcProductInfo/AtcProductInfo";
import { useAddToCartWizardContext } from "../AddToCartWizard";
import { Alert } from "~/common/m3/Alert/Alert";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";
import classNames from "classnames";
import AtcProductPriceInfo from "../../v2/AtcProductPriceInfo/AtcProductPriceInfo";
import { useIsMinTabletSize, useIsMinDesktopSize } from "../../../../common/hooks/useMediaQuery";

interface Props {
  productDescriptor: ProductDescriptor;
}

export const ErrorLoadingModal = ({ productDescriptor }: Props) => {
  const isTablet = useIsMinTabletSize();
  const isDesktop = useIsMinDesktopSize();

  const { t, getModalProps, getMainCls, getCloseBtn, closePopup } = useAddToCartWizardContext();
  const modalProps = getModalProps();
  const mainCls = getMainCls();

  return (
    <Modal
      size={isDesktop ? ModalSize.MEDIUM : ModalSize.TABLET}
      onClose={closePopup}
      noPadding={!isTablet}
      footerClassName={classNames(!isTablet && "scha__add-to-cart-popup-footer")}
      footerChildren={getCloseBtn(t("close"), !isTablet)} {...modalProps}
    >
      <div className={classNames(mainCls, "scha__atc-popup-continer")}>
        <div className="scha__atc-popup--column-info">
          <AtcProductInfo descriptor={productDescriptor}/>
        </div>
        <div className="scha__atc-popup--column-packaging__wrapper scha__atc-popup--column-packaging">
          <div className="w-100">
            <Alert severity="error">{t("addProduct.wsError")}</Alert>
          </div>
          <div>
            <AtcProductPriceInfo
              descriptor={productDescriptor}
              quantity={null}
              price={null}
              priceUnit={1}
              onChange={() => {}}
              disabled={true}
              priceReference={""}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
